module.exports = __webpack_public_path__ + "img/description.03bf1c40.svg";